import { FC } from 'react'

import {
  Dropdown,
  FilterButton,
  useDateRangeFormat,
  useDropdown,
} from '@revolut-internal/ui-kit'

import { RangeFilterContent, RangeFilterValue } from './RangeFilterContent'

type RangeFilterProps = {
  timeRange: RangeFilterValue
  hasDefaultState: boolean
  onChange: (timeRange: RangeFilterValue) => void
  onClear: VoidFunction
}

export const RangeFilter: FC<RangeFilterProps> = ({
  timeRange,
  hasDefaultState,
  onChange,
  onClear,
}) => {
  const dateFormat = useDateRangeFormat({
    style: 'precise',
  })
  const dropdown = useDropdown()

  const from = timeRange.timeRange.from
  const to = timeRange.timeRange.to

  const handleClear = () => {
    onClear()
    dropdown.getTargetProps().onClose()
  }

  const handleFilterSave = (range: RangeFilterValue | null) => {
    if (!range) {
      handleClear()
    } else {
      onChange(range)
      dropdown.getTargetProps().onClose()
    }
  }

  const rangeLabel =
    from && to && dateFormat(timeRange.timeRange.from, timeRange.timeRange.to)

  return (
    <>
      <FilterButton
        useIcon="Calendar"
        aria-label="Range filter"
        active={!hasDefaultState}
        onClear={!hasDefaultState ? handleClear : undefined}
        {...dropdown.getAnchorProps()}
      >
        {rangeLabel ?? 'Date'}
      </FilterButton>
      <Dropdown {...dropdown.getTargetProps()} maxHeight="100%">
        <RangeFilterContent
          timeRange={timeRange}
          timeLabel="Shift start range"
          shouldValidateTime={false}
          supportsTime
          supportsOnlyAdjacentDates
          onSave={handleFilterSave}
        />
      </Dropdown>
    </>
  )
}
